import { render, staticRenderFns } from "./ReportBulkSubmitter.vue?vue&type=template&id=4fa90908&scoped=true&"
import script from "./ReportBulkSubmitter.vue?vue&type=script&lang=js&"
export * from "./ReportBulkSubmitter.vue?vue&type=script&lang=js&"
import style0 from "./ReportBulkSubmitter.vue?vue&type=style&index=0&id=4fa90908&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa90908",
  null
  
)

export default component.exports